var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2724_64333",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2724_64333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 21C5.25 21 4.50833 20.8166 3.775 20.45C3.04167 20.0833 2.45 19.6 2 19C2.43333 19 2.875 18.8291 3.325 18.4875C3.775 18.1458 4 17.65 4 17C4 16.1666 4.29167 15.4583 4.875 14.875C5.45833 14.2916 6.16667 14 7 14C7.83333 14 8.54167 14.2916 9.125 14.875C9.70833 15.4583 10 16.1666 10 17C10 18.1 9.60833 19.0416 8.825 19.825C8.04167 20.6083 7.1 21 6 21ZM6 19C6.55 19 7.02083 18.8041 7.4125 18.4125C7.80417 18.0208 8 17.55 8 17C8 16.7166 7.90417 16.4791 7.7125 16.2875C7.52083 16.0958 7.28333 16 7 16C6.71667 16 6.47917 16.0958 6.2875 16.2875C6.09583 16.4791 6 16.7166 6 17C6 17.3833 5.95417 17.7333 5.8625 18.05C5.77083 18.3666 5.65 18.6666 5.5 18.95C5.58333 18.9833 5.66667 19 5.75 19H6ZM11.75 15L9 12.25L17.95 3.29996C18.1333 3.11663 18.3625 3.0208 18.6375 3.01246C18.9125 3.00413 19.15 3.09996 19.35 3.29996L20.7 4.64996C20.9 4.84996 21 5.0833 21 5.34996C21 5.61663 20.9 5.84996 20.7 6.04996L11.75 15Z",
    fill: "#707072"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArt);
export default __webpack_public_path__ + "static/media/Art.25539f77.svg";
export { ForwardRef as ReactComponent };